import { useCallback, useEffect, useState } from 'react';
import { DUEL_AI_PREDICTIONS_OPEN_STORAGE_PREFIX } from '@/constants';
import { useAuth } from '@/hooks/data/auth';

function storageKey(userId: string | undefined): string {
  return `${DUEL_AI_PREDICTIONS_OPEN_STORAGE_PREFIX}${userId ?? 'anon'}`;
}

function readOpen(key: string): boolean {
  try {
    const v = localStorage.getItem(key);
    if (v === '0') {
      return false;
    }
    if (v === '1') {
      return true;
    }
    return true;
  } catch {
    return true;
  }
}

function writeOpen(key: string, open: boolean): void {
  try {
    localStorage.setItem(key, open ? '1' : '0');
  } catch {
    // ignore quota / private mode
  }
}

/**
 * Persisted open/closed state for the duel page AI Predictions collapsible (per CrowdFPL user, localStorage).
 */
export function useDuelAiPredictionsOpenPreference(): [boolean, (open: boolean) => void] {
  const userId = useAuth((s) => s.user?.id);
  const key = storageKey(userId);

  const [open, setOpen] = useState(() => readOpen(storageKey(useAuth.getState().user?.id)));

  useEffect(() => {
    setOpen(readOpen(key));
  }, [key]);

  const setOpenPersisted = useCallback(
    (next: boolean) => {
      setOpen(next);
      writeOpen(key, next);
    },
    [key],
  );

  return [open, setOpenPersisted];
}
